import { Link } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";
import Spinner from "../../components/Spinner";
import { toast } from "react-toastify";
import Modal from "../../components/Modal";
import { IoMdClose } from "react-icons/io";
import { IoCheckmark } from "react-icons/io5";
import remove_recipient from "../../assets/icons/remove_recipient.svg";
import GenerateCardPopup from "../../components/GenerateCardPopup";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import SidePanel from "../../components/SidePanel";

const AddRecipient = () => {
  const [saveLoader, setSaveLoader] = useState(false);
  const [saveGenerateLoader, setSaveGenerateLoader] = useState(false);
  const [cancelModal, setCancelModal] = useState(false);
  const [orderModal, setOrderModal] = useState(false);
  const [selectedCard, setSelectedCard] = useState("");
  const [selectedCardID, setSelectedCardID] = useState("");

  const [data, setData] = useState({
    customerId: "",
    fullName: "",
    dob: "",
    relationShip: "",
    gender: "",
    characterTraits: [],
    email: "",
    anniversaryDate: "",
    // babyshowerDate: "",
    // graduationDate: "",
    // housewarmingDate: "",
    // occasionanniversaryDate: "",
    streetAddress: "",
    city: "",
    stateId: "",
    zipCode: "",
  });

  const [selectedOccasion, setSelectedOccasion] = useState([]);
  const [states, setStates] = useState([]);
  const [occasion, setOccasion] = useState([]);
  const [recipients, setRecipients] = useState([]);
  const [customerId, setCustomerId] = useState("");
  const [filteredOcassions, setFilteredOcassions] = useState([]);

  const [status, setStatus] = useState("");
  const animatedComponents = makeAnimated();

  const toggleCancelModal = () => {
    setCancelModal(!cancelModal);
  };

  const toggleOrderModal = () => {
    setOrderModal(!orderModal);
  };

  useEffect(() => {
    const recipientData = JSON.parse(localStorage.getItem("recipientData"));
    if (recipientData) {
      setData((prevData) => ({
        ...prevData,
        ...recipientData,
      }));
      setStatus(recipientData.anniversaryDate ? "Married" : "Single");
    }
  }, []);

  useEffect(() => {
    const fetchOccasion = async () => {
      const token = localStorage?.getItem("token");
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/event/get-active-event`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "x-sh-auth": token,
            },
          }
        );
        const res = await response.json();
        if (res.code === 200) {
          setOccasion(res.data);
        }
      } catch (error) {}
    };
    fetchOccasion();
  }, []);

  useEffect(() => {
    const fetchStates = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/state/active_state_listing`
        );
        const res = await response.json();
        if (res.code === 200) {
          setStates(res.data);
        }
      } catch (error) {}
    };
    fetchStates();
  }, []);

  useEffect(() => {
    const fetchMe = async () => {
      const token = localStorage.getItem("token");
      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/api/auth/me`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "x-sh-auth": token,
            },
          }
        );
        const data = await res.json();
        if (data.code === 200) {
          setCustomerId(data.detail._id);
        }
      } catch (error) {}
    };
    fetchMe();
  }, []);

  useEffect(() => {
    const fetchRecipients = async () => {
      const customerID = localStorage?.getItem("ID");
      const token = localStorage?.getItem("token");
      if (!customerID || !token) return;
      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/api/customer/get-customer-recipients/${customerID}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "x-sh-auth": token,
            },
          }
        );
        const data = await res.json();
        setRecipients(data.data || []);
      } catch (error) {}
    };
    fetchRecipients();
  }, []);

  const handleOccasionChange = (selectedOptions) => {
    setSelectedOccasion(selectedOptions);
    const eventId = selectedOptions.map((option) => option.value);
    setData((prevData) => ({ ...prevData, eventsId: eventId }));
  };

  const handleChange = (event) => {
    const { name, value } = event.target;

    setData((prevData) => ({
      ...prevData,
      [name]: value, // Dynamically update the corresponding field
    }));
  };
  const handleGenderSelection = (gender) => {
    setData((prevData) => ({ ...prevData, gender }));
  };

  const isTraitSelected = (trait) => data.characterTraits.includes(trait);

  const handleTraitSelection = (trait) => {
    setData((prevData) => ({
      ...prevData,
      characterTraits: isTraitSelected(trait)
        ? prevData.characterTraits.filter((t) => t !== trait)
        : [...prevData.characterTraits, trait],
    }));
  };
  const handleSave = async () => {
    setSaveLoader(true);
    if (recipients.find((recipient) => recipient.email === data.email)) {
      toast.error("Recipient with this email already exists");
      setSaveLoader(false);
      return;
    }
    if (
      !data.fullName ||
      !data.dob ||
      !data.relationShip ||
      !data.email ||
      !data.eventsId ||
      !data.streetAddress ||
      !data.city ||
      !data.stateId ||
      !data.zipCode
    ) {
      toast.error("Please fill all the fields");
      setSaveLoader(false);
      return;
    }
    // if (status === "Single") {
    //   delete data.anniversaryDate;
    // }

    if (data.characterTraits.length < 3) {
      toast.error("Please select at least 3 character traits");
      setSaveLoader(false);
      return;
    }

    const token = localStorage?.getItem("token");
    data.customerId = customerId;
    if (!token || !customerId) {
      toast.error("Not Authorized");
      setSaveLoader(false);
      return;
    }

    occasion.forEach((occasion) => {
      const fieldName = normalizeEventName(occasion?.name);
      if (
        !filteredOcassions.some((filtered) => filtered.name === occasion.name)
      ) {
        delete data[fieldName]; // Delete the dynamically generated field
      }
    });

    for (const item of filteredOcassions) {
      const fieldName = normalizeEventName(item.name); // Dynamically create the field name
      // Log field values

      // If the event has a date and the corresponding field in data is empty
      if (item.date && !data[fieldName]) {
        toast.error(`Please fill the date for ${item.name}`);
        setSaveLoader(false);
        return; // Exit the function immediately on first error
      }
      if (data[fieldName]) {
        const userDate = new Date(data[fieldName]); // Assume data[fieldName] is a valid date string
        const utcDate = userDate.toISOString(); // Converts to UTC in ISO format

        // You can save the utcDate back to data or use it as needed
        data[fieldName] = utcDate; // Optionally update the data object
      }
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/recipient/add-recipient`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-sh-auth": token,
          },
          body: JSON.stringify(data),
        }
      );
      const res = await response.json();
      setSaveLoader(false);
      if (res.code === 200) {
        toast.success("Recipient added successfully");
        localStorage.removeItem("recipientData");
        setTimeout(() => {
          window.location.href = "/dashboard/address_book";
        }, 2000);
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      toast.error("Failed to add recipient");
      setSaveLoader(false);
    }
  };

  const handleSaveGenerate = async () => {
    setSaveGenerateLoader(true);
    if (recipients.find((recipient) => recipient.email === data.email)) {
      toast.error("Recipient with this email already exists");
      setSaveGenerateLoader(false);
      return;
    }
    if (
      !data.fullName ||
      !data.dob ||
      !data.relationShip ||
      !data.email ||
      !data.eventsId ||
      !data.streetAddress ||
      !data.city ||
      !data.stateId ||
      !data.zipCode
    ) {
      toast.error("Please fill all the fields");
      setSaveGenerateLoader(false);
      return;
    }

    // if (status === "Single" && data.anniversaryDate) {
    //   toast.error(
    //     "Marital status is set to single please change the status to married to set anniversary date"
    //   );
    //   // delete data.anniversaryDate;
    //   setSaveGenerateLoader(false);
    //   return;
    // }

    if (data.characterTraits.length < 3) {
      toast.error("Please select at least 3 character traits");
      setSaveGenerateLoader(false);
      return;
    }

    const token = localStorage?.getItem("token");
    data.customerId = customerId;
    if (!token || !customerId) {
      toast.error("Not Authorized");
      setSaveGenerateLoader(false);
      return;
    }

    occasion.forEach((occasion) => {
      const fieldName = normalizeEventName(occasion?.name);
      if (
        !filteredOcassions.some((filtered) => filtered.name === occasion.name)
      ) {
        delete data[fieldName]; // Delete the dynamically generated field
      }
    });
    for (const item of filteredOcassions) {
      const fieldName = normalizeEventName(item.name); // Dynamically create the field name
      // Log field values

      // If the event has a date and the corresponding field in data is empty
      if (item.date && !data[fieldName]) {
        toast.error(`Please fill the date for ${item.name}`);
        setSaveLoader(false);
        return; // Exit the function immediately on first error
      }
      if (data[fieldName]) {
        const userDate = new Date(data[fieldName]); // Assume data[fieldName] is a valid date string
        const utcDate = userDate.toISOString(); // Converts to UTC in ISO format

        // You can save the utcDate back to data or use it as needed
        data[fieldName] = utcDate; // Optionally update the data object
      }
    }
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/recipient/add-recipient`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-sh-auth": token,
          },
          body: JSON.stringify(data),
        }
      );
      const res = await response.json();
      setSaveGenerateLoader(false);
      if (res.code === 200) {
        toast.success("Recipient added successfully");
        localStorage.removeItem("recipientData");
        toggleOrderModal();
        setSelectedCardID(data.selectedCardID);
        setSelectedCard(data.selectedCard);
      } else if (
        res.code === 400 &&
        res.message === "Please subscribe first!"
      ) {
        toast.error(
          "Maximum of 3 recipients allowed in the free version. Please subscribe for more."
        );
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      toast.error("Failed to add recipient");
      setSaveGenerateLoader(false);
    }
  };

  // not-fixed events date

  useEffect(() => {
    if (occasion.length > 0) {
      const temp = occasion.filter(
        (item) =>
          selectedOccasion.some((it) => it.value === item._id) &&
          item.category === "not-fixed"
      );
      setFilteredOcassions(temp);
    }
  }, [selectedOccasion, occasion]);
  const normalizeEventName = (eventName) => {
    return (
      eventName
        .toLowerCase()
        .replace(/[^a-z0-9]/g, "") // Remove non-alphanumeric characters (e.g., apostrophes, spaces)
        .replace(/\s+/g, "") // Remove spaces
        .replace(/^([a-z])/g, (match) => match.toLowerCase()) + "Date"
    ); // Ensure camelCase and add 'Date'
  };
  useEffect(() => {
    if (filteredOcassions.length > 0) {
      setData((prevData) => {
        const newFields = filteredOcassions.reduce((acc, { name }) => {
          const fieldName = normalizeEventName(name);
          if (!prevData[fieldName]) acc[fieldName] = "";
          return acc;
        }, {});

        if (Object.keys(newFields).length === 0) return prevData;
        return { ...prevData, ...newFields };
      });
    }
  }, [filteredOcassions]);

  return (
    // <section className="flex max-w-[1200px] mx-auto">
    <section className="flex mx-auto px-4 sm:px-2">
      <SidePanel />
      {cancelModal && (
        <Modal toggleModal={toggleCancelModal}>
          <div className="flex flex-col items-center justify-center">
            <div className="bg-gray-800 w-full h-fit p-2 px-4 py-3 rounded-t-lg flex items-center justify-between">
              <h1 className="text-2xl text-white">Cancel Add Recipient</h1>
              <IoMdClose
                size={30}
                color="white"
                className="cursor-pointer"
                onClick={toggleCancelModal}
              />
            </div>
            <div className="border-2 border-black border-dashed p-5 m-10 rounded-lg flex flex-col items-center justify-center">
              <img
                src={remove_recipient}
                alt="remove_recipient"
                className="w-[40%] m-5"
              />
              <p className="text-center my-3 text-lg">
                Are you sure you want to Cancel this Add Recipient Process?
              </p>
              <div className="flex items-center justify-center gap-x-4 w-full text-xl">
                <button
                  className="border-2 border-primary text-primary hover:bg-gray-100 py-2 px-8 rounded-sm flex items-center justify-center gap-x-2"
                  onClick={toggleCancelModal}
                >
                  <IoMdClose size={30} />
                  <span className="font-medium">No</span>
                </button>
                <Link to="/dashboard/address_book">
                  <button className="bg-primary hover:bg-primary-dark border-2 border-primary text-white py-2 px-8 rounded-sm flex items-center justify-center gap-x-2">
                    <IoCheckmark size={30} />
                    <span className="font-medium">Yes</span>
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </Modal>
      )}
      {orderModal && (
        <GenerateCardPopup
          toggleOrderModal={toggleOrderModal}
          selectedCard={selectedCard}
          selectedCardID={selectedCardID}
          data={data}
        />
      )}
      {/* <div className="w-full xl:pl-[20%] sm:pl-0 pt-[6rem] overflow-y-auto"> */}
      <div className="w-full xl:pl-[20%] sm:pl-0 h-[calc(100vh-6rem)] overflow-y-auto pt-[6rem]">
        <h3 className="mb-5 pl-2">
          <Link to="/dashboard/address_book" className="hover:underline">
            Address Book
          </Link>
          {" >"} <span className="text-primary pl-1">Add Recipients</span>
        </h3>
        <div className="pl-2 py-3 flex items-center justify-between border-b-2 gap-5 border-gray-300">
          <h1 className="text-3xl text-secondary font-semibold w-full flex-1">
            Add Recipients
          </h1>
        </div>
        <div className=" md:mx-4 m-2 my-10">
          <h1 className="text-2xl text-secondary font-semibold">
            General Information
          </h1>
          <div className="flex flex-col  my-3 w-full">
            <div className="flex md:flex-row flex-col w-full">
              <div className="flex flex-col w-full">
                <label className="my-2 text-lg text-gray-400">Full Name</label>
                <input
                  type="text"
                  name="fullName"
                  value={data.fullName}
                  onChange={handleChange}
                  required
                  placeholder="Please enter Recipient's full name"
                  className="bg-none border-b-2 py-3 focus:outline-none placeholder:text-gray-300 w-full sm:w-[90%]"
                />
              </div>
              <div className="flex flex-col w-full">
                <label className="my-2 text-lg text-gray-400">
                  Relationship
                </label>
                <select
                  className="bg-white border-b-2 border-gray-300 py-3 w-full"
                  name="relationShip"
                  value={data.relationShip}
                  required
                  onChange={handleChange}
                >
                  <option value="">--Select--</option>
                  <option value="Father">Father</option>
                  <option value="Mother">Mother</option>
                  <option value="Uncle">Uncle</option>
                  <option value="Aunt">Aunt</option>
                  <option value="Both Parents">Both Parents</option>
                  <option value="Husband">Husband</option>
                  <option value="Wife">Wife</option>
                  <option value="A Couple">A Couple</option>
                  <option value="Son">Son</option>
                  <option value="Daughter">Daughter</option>
                  <option value="Sister">Sister</option>
                  <option value="Brother">Brother</option>
                  {/* <option value="GF">GF</option> */}
                  {/* <option value="BF">BF</option> */}
                  <option value="Grandad">Grandad</option>
                  <option value="Grandmom">Grandmom</option>
                  <option value="Grandson">Grandson</option>
                  <option value="Granddaughter">Granddaughter</option>
                </select>
              </div>
            </div>
            <div className="flex xl:flex-row flex-col items-center w-full">
              <div className="flex flex-col w-full">
                <label className="my-2 text-lg text-gray-400 ">Birthday</label>
                <input
                  type="date"
                  name="dob"
                  value={data.dob}
                  onChange={handleChange}
                  required
                  max={new Date().toISOString().split("T")[0]}
                  placeholder="00/00/0000"
                  className="py-3 bg-none border-b-2 border-gray-300 focus:outline-none placeholder:text-gray-300 xl:w-[90%] w-full mr-6 mb-6 relative top-3"
                />
              </div>
              <div className="flex flex-col w-full">
                <label className="my-2 text-lg text-gray-400">E-mail</label>
                <input
                  type="email"
                  name="email"
                  value={data.email}
                  onChange={handleChange}
                  placeholder="Please enter your e-mail"
                  className="py-3 bg-none border-b-2 border-gray-300 focus:outline-none placeholder:text-gray-300 w-full"
                />
              </div>
            </div>
            {/* <h3 className="text-lg text-gray-400 mt-3">Marital status</h3>
            <select
              className="bg-white border-b-2 border-gray-300 py-3 w-full"
              name="status"
              value={status}
              required
              onChange={(e) => setStatus(e.target.value)}
            >
              <option value="">--Select--</option>
              <option value="Single">Single</option>
              <option value="Married">Married</option>
            </select> */}
            {/* {status === "Married" && (
              <div className="flex flex-col w-full my-3">
                <label className="my-2 text-lg text-gray-400 ">
                  Anniversary Date
                </label>
                <input
                  type="date"
                  name="anniversaryDate"
                  value={data.anniversaryDate}
                  onChange={handleChange}
                  required
                  placeholder="00/00/0000"
                  className="py-3 bg-none border-b-2 border-gray-300 placeholder:text-gray-300 w-full mr-6 mb-6"
                />
              </div>
            )} */}
            <h3 className="text-lg text-gray-400 mt-3">Gender</h3>
            <div className="flex items-center my-5 gap-x-5">
              <button
                className={`xl:px-20 w-full rounded-md py-2 flex items-center justify-center text-xl border-2 ${
                  data.gender === "male"
                    ? "bg-primary border-primary text-black"
                    : "border-gray-300 hover:border-primary hover:text-primary"
                }`}
                onClick={() => handleGenderSelection("male")}
              >
                Male 🧔🏻‍
              </button>
              <button
                className={`xl:px-20 w-full rounded-md py-2 flex items-center justify-center text-xl border-2 ${
                  data.gender === "female"
                    ? "bg-primary border-primary text-black"
                    : "border-gray-300 hover:border-primary hover:text-primary"
                }`}
                onClick={() => handleGenderSelection("female")}
              >
                Female 👩🏻
              </button>
            </div>
            <div className="flex flex-col w-full mb-5">
              <label className="text-lg text-gray-400">Occasion</label>
              <Select
                styles={{
                  control: (baseStyles) => ({
                    ...baseStyles,
                    padding: "5px",
                    borderRadius: "5px",
                    border: "2px solid #bbb",
                  }),
                  multiValue: (styles) => ({
                    ...styles,
                    backgroundColor: "#F66061",
                    borderRadius: "10px",
                  }),
                  multiValueLabel: (styles) => ({
                    ...styles,
                    color: "white",
                    padding: "5px",
                  }),
                  multiValueRemove: (styles) => ({
                    ...styles,
                    color: "white",
                    ":hover": {
                      backgroundColor: "#F66061",
                      color: "white",
                    },
                    borderRadius: "10px",
                  }),
                  option: (styles, { isFocused, isSelected }) => ({
                    ...styles,
                    backgroundColor: isFocused
                      ? "#F66061"
                      : isSelected
                      ? "#F66061"
                      : null,
                    color: isFocused || isSelected ? "white" : "#F66061",
                    ":active": {
                      ...styles[":active"],
                      backgroundColor: isSelected ? "#F66061" : null,
                    },
                  }),
                }}
                className="my-3"
                closeMenuOnSelect={false}
                components={animatedComponents}
                isMulti
                required
                options={occasion.map((occ) => ({
                  value: occ._id,
                  label: occ.name,
                }))}
                onChange={handleOccasionChange}
                value={selectedOccasion}
              />
            </div>
            <div className="flex flex-col w-full mb-3">
              <>
                {filteredOcassions && filteredOcassions.length > 0
                  ? filteredOcassions.map((item) => {
                      const fieldName = normalizeEventName(item.name);

                      if (item.name === "Anniversary") {
                        return (
                          <div className="flex flex-col w-full my-3">
                            <label className="my-2 text-lg text-gray-400 ">
                              {item.name}
                            </label>
                            <input
                              type="date"
                              name="anniversaryDate"
                              value={data.anniversaryDate}
                              onChange={handleChange}
                              required
                              placeholder="00/00/0000"
                              className="py-3 bg-none border-b-2 border-gray-300 placeholder:text-gray-300 w-full mr-6 mb-6"
                            />
                          </div>
                        );
                      } else {
                        return (
                          <div className="flex flex-col w-full m-1">
                            <React.Fragment key={item._id}>
                              <label className="my-2 text-lg text-gray-400">
                                {item.name}
                              </label>
                              <input
                                type="date"
                                name={fieldName} // Use the normalized field name
                                value={data[fieldName] || ""} // Bind the corresponding date from `data`
                                onChange={handleChange} // Handle change event
                                required
                                placeholder="00/00/0000"
                                className="py-3 bg-none border-b-2 border-gray-300 placeholder:text-gray-300 w-full mr-6 mb-6"
                              />
                            </React.Fragment>
                          </div>
                        );
                      }
                    })
                  : null}
              </>
              {/* {selectedOccasion.map((occasion, index) => (
                <div>
                  {occasion.label == "Occasion Anniversary" && (
                    <>
                      <div className="flex flex-col w-full m-1">
                        <label className="my-2 text-lg text-gray-400 ">
                          Occasion Anniversary Date
                        </label>
                        <input
                          type="date"
                          name="occasionanniversaryDate"
                          value={data.occasionanniversaryDate}
                          onChange={handleChange}
                          required
                          placeholder="00/00/0000"
                          className="py-3 bg-none border-b-2 border-gray-300 placeholder:text-gray-300 w-full mr-6 mb-6"
                        />
                      </div>
                    </>
                  )}
                  {occasion.label == "Baby Shower" && (
                    <>
                      <div className="flex flex-col w-full m-1">
                        <label className="my-2 text-lg text-gray-400 ">
                          Baby Shower Date
                        </label>
                        <input
                          type="date"
                          name="babyshowerDate"
                          value={data.babyshowerDate}
                          onChange={handleChange}
                          required
                          placeholder="00/00/0000"
                          className="py-3 bg-none border-b-2 border-gray-300 placeholder:text-gray-300 w-full mr-6 mb-6"
                        />
                      </div>
                    </>
                  )}{" "}
                  {occasion.label == "Graduation" && (
                    <>
                      <div className="flex flex-col w-full m-1">
                        <label className="my-2 text-lg text-gray-400 ">
                          Graduation Date
                        </label>
                        <input
                          type="date"
                          name="graduationDate"
                          value={data.graduationDate}
                          onChange={handleChange}
                          required
                          placeholder="00/00/0000"
                          className="py-3 bg-none border-b-2 border-gray-300 placeholder:text-gray-300 w-full mr-6 mb-6"
                        />
                      </div>
                    </>
                  )}{" "}
                  {occasion.label == "House Warming" && (
                    <>
                      <div className="flex flex-col w-full m-1">
                        <label className="my-2 text-lg text-gray-400 ">
                          House Warming
                        </label>
                        <input
                          type="date"
                          name="housewarmingDate"
                          value={data.housewarmingDate}
                          onChange={handleChange}
                          required
                          placeholder="00/00/0000"
                          className="py-3 bg-none border-b-2 border-gray-300 placeholder:text-gray-300 w-full mr-6 mb-6"
                        />
                      </div>
                    </>
                  )}
                </div>
              ))} */}
            </div>

            <h3 className="text-lg text-gray-400">
              Character Traits (Multiple Select)
            </h3>
            <div className="grid lg:grid-cols-4 grid-cols-3 gap-2 place-items-center my-3">
              {[
                "Kind",
                "Loving",
                "Wise",
                "Honest",
                "Generous",
                "Humorous",
                "Compasionate",
                "Patient",
                "Adventurous",
                "Gentle",
                "Loyal",
                "Creative",
              ].map((trait) => (
                <button
                  key={trait}
                  className={`w-full rounded-md py-3 flex items-center justify-center text-xl border-2 ${
                    isTraitSelected(trait)
                      ? "bg-primary border-primary text-white"
                      : "border-gray-300 hover:border-primary hover:text-primary"
                  }`}
                  onClick={() => handleTraitSelection(trait)}
                >
                  {trait}
                </button>
              ))}
            </div>
          </div>
          <h1 className="text-2xl text-secondary font-semibold">
            Location Detail
          </h1>
          <div className="flex flex-col my-3 w-full">
            <div className="flex flex-col w-full my-2">
              <label className="text-lg text-gray-400">Street Address</label>
              <input
                type="text"
                name="streetAddress"
                value={data.streetAddress}
                required
                onChange={handleChange}
                className="py-3 bg-none border-b-2 focus:outline-none border-gray-300 placeholder:text-gray-300 w-full"
              />
            </div>
            <div className="flex flex-col w-full my-2">
              <label className="text-lg text-gray-400">City</label>
              <input
                type="text"
                name="city"
                value={data.city}
                required
                onChange={handleChange}
                className="py-3 bg-none border-b-2 focus:outline-none border-gray-300 placeholder:text-gray-300 w-full"
              />
            </div>
            <div className="flex flex-col w-full my-2">
              <label className="text-lg text-gray-400">Zip Code</label>
              <input
                type="number"
                name="zipCode"
                value={data.zipCode}
                required
                maxLength={5}
                max={5}
                onChange={(e) => {
                  // Ensure the input doesn't exceed 5 digits
                  if (e.target.value.length <= 5) {
                    handleChange(e);
                  }
                }}
                className="py-3 bg-none border-b-2 focus:outline-none border-gray-300 placeholder:text-gray-300 w-full"
              />
            </div>
            <div className="flex flex-col w-full my-2">
              <label className="text-lg text-gray-400">State</label>
              <select
                name="stateId"
                value={data.stateId}
                onChange={handleChange}
                required
                className="py-3 bg-white border-b-2 border-gray-300 focus:outline-none placeholder:text-gray-300 w-full"
              >
                <option value="">Choose State</option>
                {/* {states.map((state) => (
                <option key={state._id} value={state._id}>
                  {state.state}
                </option>
              ))} */}
                {states
                  .slice() // Create a copy to avoid mutating the original array
                  .sort((a, b) => a.state.localeCompare(b.state)) // Sort alphabetically
                  .map((state) => (
                    <option key={state._id} value={state._id}>
                      {state.state}
                    </option>
                  ))}
              </select>
            </div>
            <div className="flex md:flex-row flex-col mx-auto w-[70%] items-center gap-3 flex-grow mt-12">
              {saveLoader ? (
                <div className="w-full">
                  <Spinner props=" " size={"80"} />
                </div>
              ) : (
                <button
                  onClick={handleSave}
                  className="bg-primary rounded-md py-3 px-5 text-white sm:text-xl w-full hover:bg-primary-dark"
                >
                  Save
                </button>
              )}
              <button
                onClick={toggleCancelModal}
                className="bg-primary rounded-md py-3 px-5 text-white sm:text-xl w-full hover:bg-primary-dark"
              >
                Cancel
              </button>
              {saveGenerateLoader ? (
                <div className="w-full">
                  <Spinner props=" " size={"80"} />
                </div>
              ) : (
                <button
                  onClick={handleSaveGenerate}
                  className="bg-primary rounded-md py-3 px-8 text-white sm:text-xl w-full hover:bg-primary-dark"
                >
                  Save & Generate
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AddRecipient;
